module.exports = __webpack_public_path__ + "statics/img/31.jpg";